
const auth = {
  'auth.signIn': 'Sign In',
  'auth.signUp': 'Sign Up',
  'auth.signOut': 'Sign Out',
  'auth.profile': 'Profile',
  'auth.forgotPassword': 'Forgot Password?',
  'auth.resetPassword': 'Reset Password',
  'auth.noAccount': 'Don\'t have an account?',
  'auth.haveAccount': 'Already have an account?',
  'auth.emailVerification': 'Email Verification',
  'auth.emailVerificationSent': 'A verification email has been sent to your email address. Please check your inbox and follow the instructions to verify your account.',
  'auth.emailVerificationInfo': 'Before you can sign in, please verify your email address.',
  'auth.verificationSuccess': 'Your email has been successfully verified!',
  'auth.verificationError': 'There was an error verifying your email.',
  'auth.passwordRequirements': 'Password must:',
  'auth.passwordLength': 'Be at least 8 characters long',
  'auth.passwordUppercase': 'Include at least one uppercase letter',
  'auth.passwordLowercase': 'Include at least one lowercase letter',
  'auth.passwordNumber': 'Include at least one number',
  'auth.passwordSpecial': 'Include at least one special character',
  'auth.passwordsDoNotMatch': 'Passwords do not match',
  'auth.emailsDoNotMatch': 'Emails do not match',
  'auth.invalidEmail': 'Please enter a valid email address',
  'auth.mandatoryField': 'This field is required',
  'auth.usernameLength': 'Username must be between 3 and 20 characters',
  'auth.usernameFormat': 'Username can only contain letters, numbers, underscores, and hyphens',
  'auth.nameFormat': 'Can only contain letters, spaces, hyphens, and apostrophes',
  'auth.nameMaxLength': 'Must not exceed 50 characters',
  'auth.phoneFormat': 'Please enter a valid phone number',
  'auth.addressFormat': 'Address contains invalid characters',
  'auth.addressMaxLength': 'Address must not exceed 200 characters',
  'auth.cityFormat': 'City can only contain letters, spaces, hyphens, and apostrophes',
  'auth.cityMaxLength': 'City must not exceed 100 characters',
  'auth.postalCodeFormat': 'Postal code can only contain letters, numbers, spaces, and hyphens',
  'auth.postalCodeMaxLength': 'Postal code must not exceed 20 characters',
  'auth.emailMaxLength': 'Email address is too long',
  'auth.passwordMaxLength': 'Password must not exceed 128 characters',
  'auth.phoneMinLength': 'Phone number is too short',
  'auth.phoneMaxLength': 'Phone number is too long',
  'auth.suspiciousContent': 'Contains potentially harmful content',
  'auth.reservedUsername': 'Username is reserved',
  'auth.commonPassword': 'Password is too common',
  'auth.minimumAge': 'You must be at least 18 years old',
  'auth.loginError': 'Invalid email or password',
  'auth.loginRequired': 'Please sign in to view your profile',
  'auth.signUpError': 'Error creating account',
  'auth.signOutError': 'Error signing out',
  'auth.usernameTaken': 'Username is already taken',
  'auth.emailTaken': 'Email is already in use',
  'auth.firstName': 'First Name',
  'auth.lastName': 'Last Name',
  'auth.dateOfBirth': 'Date of Birth',
  'auth.gender': 'Gender',
  'auth.selectGender': 'Select Gender',
  'auth.male': 'Male',
  'auth.female': 'Female',
  'auth.other': 'Other',
  'auth.preferNotToSay': 'Prefer Not to Say',
  'auth.phone': 'Phone Number',
  'auth.phoneNumber': 'Phone number',
  'auth.email': 'Email',
  'auth.confirmEmail': 'Confirm Email',
  'auth.username': 'Username',
  'auth.password': 'Password',
  'auth.confirmPassword': 'Confirm Password',
  'auth.agreeToTerms': 'I accept the ',
  'auth.termsOfService': 'Terms of Service',
  'auth.and': ' and ',
  'auth.privacyPolicy': 'Privacy Policy',
  'auth.termsRequired': 'You must accept the Terms and Conditions',
  'auth.country': 'Country',
  'auth.selectCountry': 'Select Country',
  'auth.countryCode': 'Country Code',
  'auth.selectCountryCode': 'Select Country Code',
  'auth.userInfo': 'User Information',
  'auth.contactInfo': 'Contact Information',
  'auth.accountInfo': 'Account Information',
  'auth.welcomeBack': 'Log in to The Club',
  'auth.welcomeMessage': 'Please enter your credentials to sign in',
  'auth.createAccount': 'Create your The Club Account',
  'auth.createAccountMessage': 'Fill in the information below to create your account',
  'auth.updateProfile': 'Update Profile',
  'auth.profileUpdated': 'Profile updated successfully',
  'auth.profileUpdateError': 'Error updating profile',
  'auth.selectDate': 'Select a Date',
  'auth.selectYear': 'Select a Year',
  
  // New translations for password reset
  'auth.resetPasswordInstructions': 'Enter your email address and we\'ll send you a link to reset your password.',
  'auth.sendResetEmail': 'Send Reset Email',
  'auth.resetEmailSent': 'Reset Email Sent',
  'auth.resetEmailInstructions': 'Please check your email for instructions to reset your password.',
  'auth.resetPasswordError': 'Error Resetting Password',
  'auth.unexpectedError': 'An unexpected error occurred',
  'auth.createNewPassword': 'Create a new password for your account',
  'auth.newPassword': 'New Password',
  'auth.backToSignIn': 'Back to Sign In',
  'auth.passwordResetSuccess': 'Password Reset Successful',
  'auth.passwordResetSuccessMessage': 'Your password has been reset successfully. You will be redirected to the login page.',
  'auth.invalidResetLink': 'Invalid or expired reset link',
  'auth.tooManyAttempts': 'Too many login attempts. Please try again later.',
  
  // New translations for multi-step signup
  'auth.signUpWithGoogle': 'Sign up with Google',
  'auth.signUpWithFacebook': 'Sign up with Facebook',
  'auth.orContinueWithEmail': 'Or continue with email',
  'auth.next': 'Next',
  'auth.back': 'Back',
  'auth.stepTwoOfTwo': 'Step 2 of 2',
  
  // New translations for missing UI elements
  'auth.redirecting': 'Redirecting...',
  'auth.emailPlaceholder': 'you@example.com',
  'auth.emailPlaceholderGeneric': 'email@example.com',
  'auth.invalidRecoveryLink': 'Invalid recovery link. Please request a new password reset link.',
  'auth.passwordResetTitle': 'Reset Your Password',
  'auth.confirmNewPassword': 'Confirm New Password',
  'auth.resetPasswordSubmit': 'Reset Password',

  // Additional validation messages
  'auth.emailValidationError': 'Please enter a valid email address',
  'auth.passwordValidationMinLength': 'Password must be at least 8 characters long',
  'auth.passwordValidationUppercase': 'Password must include at least one uppercase letter',
  'auth.passwordValidationNumber': 'Password must include at least one number',
  'auth.passwordValidationSpecial': 'Password must include at least one special character',
  'auth.passwordValidationMatch': "Passwords don't match",

  // Reset password specific messages
  'auth.verifyingRecoveryLink': 'Verifying recovery link...',
  'auth.unableToVerifySession': 'Unable to verify recovery session. Please request a new password reset link.',
  'auth.unableToVerifyLink': 'Unable to verify recovery link. Please request a new password reset link.',
  'auth.invalidRecoverySession': 'Invalid recovery session. Please request a new password reset link.',
  'auth.requestNewResetLink': 'Request New Reset Link',

  // General UI messages
  'auth.emailVerifiedSignIn': 'Your email has been verified. Please sign in with your credentials.',
  'auth.unexpectedErrorOccurred': 'An unexpected error occurred',

  //Supabase Error Messages
  // Authentication errors
  'auth.supabase.invalidCredentials': 'Invalid email or password',
  'auth.supabase.emailNotConfirmed': 'Please verify your email address before signing in',
  'auth.supabase.userNotFound': 'No account found with this email address',
  'auth.supabase.passwordTooShort': 'Password must be at least 6 characters long',
  'auth.supabase.userAlreadyRegistered': 'An account with this email already exists',
  'auth.supabase.emailRateLimit': 'Too many emails sent. Please wait before requesting another',
  'auth.supabase.invalidEmail': 'Please enter a valid email address',
  'auth.supabase.signupDisabled': 'New account registration is currently disabled',
  'auth.supabase.invalidRecoveryToken': 'Invalid password recovery link',
  'auth.supabase.tokenExpired': 'This link has expired. Please request a new password reset',
  'auth.supabase.passwordTooWeak': 'Password is too weak. Please choose a stronger password',

  // Database errors
  'auth.supabase.databaseError': 'Database connection error. Please try again later',
  'auth.supabase.connectionTimeout': 'Connection timeout. Please check your internet connection',
  'auth.supabase.internalError': 'Internal server error. Please try again later',
  'auth.supabase.serviceUnavailable': 'Service temporarily unavailable. Please try again later',
  'auth.supabase.requestTimeout': 'Request timeout. Please try again',
  
  // Policy/Permission errors
  'auth.supabase.permissionDenied': 'Access denied. You do not have permission to perform this action',
  'auth.supabase.accessDenied': 'Access denied',
  'auth.supabase.insufficientPermissions': 'Insufficient permissions to complete this action',
  
  // Network errors
  'auth.supabase.networkError': 'Network connection error. Please check your internet connection',
  'auth.supabase.connectionError': 'Connection error. Please try again',
  
  // Generic patterns
  'auth.supabase.rateLimit': 'Too many requests. Please wait a moment before trying again',
  'auth.supabase.invalidToken': 'Invalid authentication token. Please sign in again',
  'auth.supabase.resourceNotFound': 'Requested resource not found',
  'auth.supabase.resourceAlreadyExists': 'This resource already exists',
  
  // Generic fallback
  'auth.supabase.genericError': 'An unexpected error occurred. Please try again',

  // Invitation code field
  'auth.sponsor': 'Invitation Code',
  'auth.sponsorMandatory': '(mandatory)',
  'auth.sponsorPlaceholder': 'Enter your invitation code',
  'auth.sponsorNotFound': 'Invalid invitation code. Please enter a valid code',
  'auth.sponsorRequired': 'A valid invitation code is required',
  'auth.needSponsor': 'Need an invitation code? Contact a The Club representative',

  // Email confirmation error
  'auth.confirmationFailed': 'Email confirmation failed. Please check your email for the latest confirmation link.',
  'auth.resendConfirmationEmail': 'Resend Confirmation Email',
  'auth.resendIn': 'Resend in {{seconds}}',
  'auth.resendSuccess': 'Confirmation email sent! Please check your inbox.',
  'auth.enterEmailToResend': 'Enter your email to resend the confirmation link',

  // Smart confirmation flow
  'auth.emailNeedsConfirmation': 'This email needs to be confirmed. A confirmation link was recently sent — please check your inbox.',
  'auth.emailConfirmationResent': 'This email needs to be confirmed. A new confirmation email has been sent — please check your inbox for the most recent link.',
  'auth.confirmationRecentlySent': 'A confirmation link was recently sent to this email. Please check your inbox.',
  'auth.confirmationNewSent': 'A new confirmation email has been sent. Please check your inbox for the most recent confirmation link.',
  'auth.confirmationSentTo': 'Confirmation email sent to:',
  'auth.verifyEmailResendInfo': 'Didn\'t receive the email?',

  // Already confirmed messages
  'auth.emailAlreadyConfirmed': 'Your email address is already verified. You can sign in with your credentials.',
  'auth.emailAlreadyConfirmedSignIn': 'Your email is already verified. Please sign in below.',
};

export default auth;
